import React, { useEffect, useState } from "react";
import Link from "next/link";
import styled, { useTheme } from "styled-components";
import { cLoadArticles } from "lib/contentful-client-wildest";
import WildestLogo from "components/icons/wildestlogo";
import ArticleCardBlock from "components/Contentful/WildestArticleBlock/ArticleCardBlock";

const OuterWrapper = styled.section`
  display: flex;
  justify-content: center;
`;

const InnerWrapper = styled.div`
  background-color: ${({ theme }) => theme.themeColors.white};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 80rem;
  width: 100%;

  ${({ theme }) => theme.mq.xl`
    border-radius: 2rem;
  `}
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 1.5rem;
  margin: 0 0 1.5rem 0;

  ${({ theme }) => theme.mq.xl`
    margin: 0 0 2.1875rem;
  `}
`;

const LogoWrapper = styled.div`
  margin: 3rem 0 1.5rem 0;

  ${({ theme }) => theme.mq.xl`
    margin: 6.25rem 0 2.1875rem;
  `}
`;

const Title = styled.h3`
  color: ${({ theme }) => theme.themeColors.darkGrey};
  font-size: 2rem;
  letter-spacing: -0.033125rem;
  line-height: 1.1;
  margin-bottom: 0.5rem;
  text-align: center;

  br {
    display: none;
  }

  ${({ theme }) => theme.mq.md`
    br {
      display: block;
    }
  `}

  ${({ theme }) => theme.mq.lg`
    br {
      display: none;
    }
  `}

  ${({ theme }) => theme.mq.xl`
    font-size: 2.25rem;
    margin-bottom: 1.5rem;
  `}
`;

const CarouselScrollWrapper = styled.div`
  position: relative;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;

  ${({ theme }) => theme.mq.xl`
    max-width: 100%;
  `}
`;

const ArticleCarousel = styled.ul`
  display: flex;
  justify-content: space-between;
  min-height: 17.9375rem;
  padding: 0 1.5rem;
  margin: 0;

  ${({ theme }) => theme.mq.xxl`
    padding: 0;
  `}
`;

const ReadMoreLinkWrapper = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGrey};
  display: flex;
  padding: 0 1.5rem;
  margin: 1.5rem 0 3.5rem;

  ${({ theme }) => theme.mq.xl`
    margin: 4.525rem auto 6.25rem;
  `}
`;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.themeColors.orange1};
  font-weight: 600;
`;

function WildestArticleBlock() {
  const theme = useTheme();
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const getWildestArticles = async () => {
      const wildestArticles = await cLoadArticles();
      setArticles(wildestArticles);
    };

    getWildestArticles().catch(console.error);
  }, []);

  return (
    <OuterWrapper>
      <InnerWrapper>
        <HeaderWrapper>
          <LogoWrapper>
            <Link href="https://www.thewildest.com/" passHref>
              <StyledLink target="_blank">
                <WildestLogo color={theme.themeColors.brown} />
              </StyledLink>
            </Link>
          </LogoWrapper>
          <Title>
            Get grooming and training tips from our friends <br />
            at The Wildest
          </Title>
        </HeaderWrapper>
        <CarouselScrollWrapper>
          <ArticleCarousel>
            {articles &&
              articles?.map((article) => {
                return (
                  <ArticleCardBlock
                    key={article?.sys?.id}
                    blockData={article?.fields}
                  />
                );
              })}
          </ArticleCarousel>
        </CarouselScrollWrapper>
        <ReadMoreLinkWrapper isBelowCarousel>
          <Link href="https://www.thewildest.com/" passHref>
            <StyledLink target="_blank">Get more good tips</StyledLink>
          </Link>
        </ReadMoreLinkWrapper>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default WildestArticleBlock;
